module.exports = __webpack_public_path__ + "assets/img/DS-master (4).5da14a94.jpg";